<template lang="pug">
.card.market-card
  .card-header.bg-more-head.collapse-more(
    :id="'heading-ou-' + id"
    data-toggle='collapse'
    :data-target="'#collapse-ou-' + id"
    :aria-controls="'collapse-ou-' + id"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $tc("m.BT_OU", 1) }}
  .collapse.show(
    :aria-labelledby="'heading-ou-' + id"
    :id="'collapse-ou-' + id"
  )
    .card-body.p-0
      .market-card-content
        .normal(v-if="mode == 0 || mode == 1")
          .normal-title {{ $t("ui.full_time") }}
          .normal-odd-area
            .normal-odd-area-oddtype
              p.mb-0 {{ $t("m.ODD_Over") }}
              p.mb-0 {{ $t("m.ODD_Under") }}
            swiper(ref="sw" :options="swiperOptions" @slideChange="handleSlideChange")
              template(v-for="(dn, i) in details['kns']")
                swiper-slide.normal-odd-area-group
                  template(v-if="details['ou'] && details['ou'][i] && details['ou'][i][11] != 0 && details['ou'][i][12] != 0 && details['ou'][i][11] != '' && details['ou'][i][12] != ''")
                    OddsItem(:odds="details['ou'][i]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" :count="i" :details="details" homeAway="1")
                  template(v-else)
                    OddsDisabled
                  template(v-if="details['ou'] && details['ou'][i] && details['ou'][i][11] != 0 && details['ou'][i][12] != 0 && details['ou'][i][11] != '' && details['ou'][i][12] != ''")
                    OddsItem(:odds="details['ou'][i]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" :count="i" :details="details" homeAway="2")
                  template(v-else)
                    OddsDisabled
              .swiper-pagination(v-if="details['kns'] > 4" slot="pagination")
        .normal(v-if="$helpers.objSize(details['ouh']) > 0 && (mode == 0 || mode == 2)")
          .normal-title {{ $t("ui.half_time") }}
          .normal-odd-area
            .normal-odd-area-oddtype
              p.mb-0 {{ $t("m.ODD_Over") }}
              p.mb-0 {{ $t("m.ODD_Under") }}
            swiper(ref="sw" :options="swiperOptions" @slideChange="handleSlideChange")
              template(v-for="(dn, i) in details['kns']")
                swiper-slide.normal-odd-area-group
                  template(v-if="details['ouh'] && details['ouh'][i] && details['ouh'][i][11] != 0 && details['ouh'][i][12] != 0 && details['ouh'][i][11] != '' && details['ouh'][i][12] != ''")
                    OddsItem(:odds="details['ouh'][i]" idx=12 :typ="oddsType" dataType="1" mode="ouh" label="over" :count="i" :details="details" homeAway="1")
                  template(v-else)
                    OddsDisabled
                  template(v-if="details['ouh'] && details['ouh'][i] && details['ouh'][i][11] != 0 && details['ouh'][i][12] != 0 && details['ouh'][i][11] != '' && details['ouh'][i][12] != ''")
                    OddsItem(:odds="details['ouh'][i]" idx=11 :typ="oddsType" dataType="1" mode="ouh" label="under" :count="i" :details="details" homeAway="2")
                  template(v-else)
                    OddsDisabled
              .swiper-pagination(v-if="details['kns'] > 4" slot="pagination")
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  },
  data() {
    return {
      activeIndex: 0,
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.sw ? this.$refs.sw.$swiper : 0;
    }
  },
  mounted() {
    this.activeIndex = this.swiper.activeIndex;
  },
  methods: {
    handleSlideChange() {
      this.activeIndex = this.swiper.activeIndex;
    }
  }
}
</script>